export interface Vec2 {
  x: number;
  y: number;
}

export function length(x: number, y: number): number {
  return Math.hypot(x, y);
}

export function distance(a: Vec2, b: Vec2): number {
  return Math.hypot(b.x - a.x, b.y - a.y);
}

/** Unit vector in the direction (x, y); (0, 0) for a zero vector. */
export function normalize(x: number, y: number): Vec2 {
  const len = Math.hypot(x, y);
  return len > 0 ? { x: x / len, y: y / len } : { x: 0, y: 0 };
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
